// import hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import { Container, Row, Col } from "react-bootstrap";
import RoutPath from "../RoutPath";
import Avatar from "./Avatar";
import AccountList from "./AccountList";
import OrderItem from "./OrderItem";

// import assets
import "../../assets/css/account.css";
import avatar from "../../assets/img/client1.png";
import { emptyCart } from "../../utils/cards-svgs";

// import data

const Orders = ({ items }) => {
    const [name, setName] = useState("mido");

    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    return (
        <section className="ocean-section wishlist-section">
            <Container>
                <Row>
                    <RoutPath />
                </Row>
                <Row>
                    {windowWidth >= 992 && (
                        <Col lg={4}>
                            <Avatar
                                avatar={avatar}
                                name={name}
                                points={120}
                                lgClass="lg-side-account-list"
                            />
                            <AccountList />
                        </Col>
                    )}
                    <Col lg={8}>
                        {items ? (
                            <>
                                <h1 className="ocean-h1">
                                    {t("account.list.requests")}
                                </h1>
                                {items.map((i) => (
                                    <OrderItem item={i} />
                                ))}
                            </>
                        ) : (
                            <>
                                <img src={emptyCart} alt="heart" />
                                <h1 className="ocean-lg-h">
                                    {t("account.empty-Orders")}
                                </h1>
                                <p className="ocean-p-grey">
                                    {t("account.empty-wishlist-txt")}
                                </p>
                                <button className="ocean-btn">
                                    {t("cart.keep-shopping")}
                                </button>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Orders;
